<template>
  <div class="relative bg-gray-50">
    <TContainer>
      <TGrid>
        <div class="col-span-12 lg:col-span-6 py-16">
          <TTitle tag="h1" size="5xl">
            <span v-html="title" />
          </TTitle>

          <TText color="text-gray-600" size="lg" classes="mb-0">
            {{ text }}
          </TText>
        </div>
      </TGrid>
    </TContainer>

    <div
      class="aspect-w-5 aspect-h-3 lg:aspect-none lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:h-full"
    >
      <div class="lg:absolute lg:h-full lg:w-full overflow-hidden">
        <div
          class="hidden lg:block absolute z-40 -left-24 inset-y-0 h-full w-48 translate-x--1/2"
        >
          <svg
            class="inset-0 h-full w-full absolute text-gray-50"
            fill="currentColor"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
            aria-hidden="true"
          >
            <polygon points="50,0 100,0 50,100 0,100" />
          </svg>
        </div>

        <TLazyimg :src="img" alt="" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
export interface propsInterface {
  title: string
  text: string
  img: string
}
defineProps<propsInterface>()
</script>
